var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNavbarSampledata(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 11C21 16.5228 16.5228 21 11 21C5.47715 21 1 16.5228 1 11M21 11C21 5.47715 16.5228 1 11 1M21 11H18.5M1 11C1 5.47715 5.47715 1 11 1M1 11H3.5M11 1V3.5M18.0784 4L12.4999 9.5M18.0784 18.0784L17.8745 17.8745C17.1827 17.1827 16.8368 16.8368 16.4331 16.5894C16.0753 16.3701 15.6851 16.2085 15.2769 16.1105C14.8166 16 14.3274 16 13.349 16L8.65096 16C7.6726 16 7.18342 16 6.72307 16.1106C6.31493 16.2086 5.92475 16.3702 5.56686 16.5895C5.1632 16.8369 4.8173 17.1828 4.12549 17.8746L3.92163 18.0784M3.92163 4L5.65808 5.73645M13 11C13 12.1046 12.1046 13 11 13C9.89543 13 9 12.1046 9 11C9 9.89543 9.89543 9 11 9C12.1046 9 13 9.89543 13 11Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavbarSampledata);
export default __webpack_public_path__ + "static/media/navbar-sampledata.342bf8f0956ab02a0783606d62f9d9ad.svg";
export { ForwardRef as ReactComponent };